<section>
  <h4>Unpaid Invoice List</h4>
  <kendo-card width="100%">
    <div class="content-wrapper">
      <app-bookkeeping-sage-invoice-filters (applyFilter)="changeFilters($event)"
        (clearFilter)="changeFilters($event)"></app-bookkeeping-sage-invoice-filters>

      <kendo-card width="100%" class="mt-8 mb-8" *ngIf="invoiceList?.length">
        <kendo-card-header style="padding: 8px 16px;">
          <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(2,minmax(0,1fr))']">
            <kendo-gridlayout-item class="select-All mb-0">
              <kendo-formfield>
                <div class="k-checkbox-wrap select-All">
                  <input #selectAllChecked type="checkbox" kendoCheckBox [(ngModel)]="selectAll"
                    [ngModelOptions]="{standalone: true}" (change)="selectAllCheckboxChange($event)"
                    [indeterminate]="selectAllInterminate" />
                  <kendo-label [for]="selectAllChecked" class="k-checkbox-label font-weight-600 checkbox-margin ml-0"
                    style="margin-bottom: 0" text="Select All"></kendo-label>
                </div>
              </kendo-formfield>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item class="actions-button mb-0">
              <h6 class="mr-16 mb-0">Total: ${{totalAmountDue | number: '1.2-2'}}</h6>
              <h6 class="ml-16 mb-0" *ngIf="selected?.length">{{selected?.length}} Selected</h6>
              <span class="mr-16" style="color:rgba(1, 24, 98, 0.08)" *ngIf="selected?.length">|</span>
              <div>
                <button kendoButton themeColor="primary" fillMode="solid" (click)="openReminderModal()"
                  [disabled]="selected?.length === 0">Send Overdue Email(s)</button>
              </div>
            </kendo-gridlayout-item>
          </kendo-gridlayout>

        </kendo-card-header>
      </kendo-card>

      <kendo-grid class="evidence-list" [data]="{
        data: invoiceList,
        total: (dataSource?.pageInfo$ | async)?.totalCount
      }" [pageSize]="pageOptions?.limit" [skip]="pageOptions?.offset" [pageable]="{
        buttonCount: 6,
        type: 'numeric',
        pageSizes: [5, 10, 25, 100],
        previousNext: true,
        responsive: true,
        position: 'bottom'
      }" (pageChange)="pageOptions?.paginate($event)" [sortable]="true" [sort]="sort" (sortChange)="sortChange($event)"
        [navigatable]="false">

        <kendo-grid-column field="id" title="" [width]="2" [sortable]="false" [width]="3" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox" kendoCheckBox [checked]="checkIfSelected(dataItem.id)"
              (click)="singleCheckboxChecked($event?.target?.checked, dataItem)" />
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="orderByOptions.CustomerName" title="Customer" [width]="10" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.customerName || "-" }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [field]="orderByOptions.InvoiceDate" title="Date" [width]="7" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.invoiceDate || "-" }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [field]="orderByOptions.CustomerEmail" title="Email" [width]="13" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.customerEmail || "-" }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="orderByOptions.InvoiceNumber" title="Invoice Number" [width]="10" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.invoiceNumber || "-" }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="orderByOptions.ReferenceNumber" title="Reference Number" [width]="13"
          [sortable]="true" [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="break-word">
              {{ dataItem?.referenceNumber || "-" }}
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="orderByOptions.CustomerCompanyName" title="Company Name" [width]="12"
          [sortable]="true" [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="break-word">
              {{ dataItem?.customerCompanyName || "-" }}
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="orderByOptions.DueDate" title="Due Date" [width]="10" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.dueDate || "-" }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="orderByOptions.TotalAmountDue" title="Open Balance" [width]="9" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.totalTxnAmountDue || "-" }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [field]="orderByOptions.DueInDays" title="Ageing" [width]="4" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ +dataItem?.dueInDays || "-" }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Actions" [width]="4" [sortable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton themeColor="secondary" fillMode="link"
              iconClass="fa-solid fa-arrow-up-right-from-square" (click)="openAgingReminderSidebar(dataItem)">
            </button>
          </ng-template>
        </kendo-grid-column>

        <ng-template #noValue>
          <p class="kendo-caption-body">-</p>
        </ng-template>
      </kendo-grid>
    </div>
  </kendo-card>
</section>
